<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
  <div class="rounded-t border-b-2 mb-0 p-6">
    <div class="text-center flex justify-between">
      <h6 class="text-primary text-lg font-bold"> نوبت ها </h6>

    </div>
  </div>

  <div class="flex flex-wrap pt-6">
    <div class="w-full lg:w-3/12 px-4">
      <div class="relative w-full mb-3">
        <label class="block text-blueGray-600 text-sm font-bold mb-2"> جستجو </label>
        <input type="text" [(ngModel)]="searchBody.title" (keyup)="getAllVisits(0)"
          class="p-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded text-sm w-full">
      </div>
    </div>
    <div class="w-full lg:w-3/12 px-4">
      <div class="relative w-full mb-3">
        <label class="block text-blueGray-600 text-sm font-bold mb-2"> نوع ویزیت</label>
        <select type="text" name="inshurance" [(ngModel)]="searchBody.type" (change)="getAllVisits(0)"
          class="border-gray-300 p-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full rtl">
          <option value="0">---</option>
          <option [value]="visitType.VideoVisit"> ویزیت تصویری</option>
          <option [value]="visitType.PhoneVisit"> ویزیت تلفنی</option>
          <option [value]="visitType.TextVisit"> ویزیت متنی </option>
          <option [value]="visitType.BodyVisit"> ویزیت حضوری </option>
        </select>
      </div>
    </div>
    <div class="w-full lg:w-3/12 px-4">
      <div class="relative w-full mb-3">
        <label class="block text-blueGray-600 text-sm font-bold mb-2"> وضعیت پرداخت</label>
        <select type="text" name="inshurance" [(ngModel)]="searchBody.paymentStatus" (change)="getAllVisits(0)"
          class="border-gray-300 p-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full rtl">
          <option value="0">---</option>
          <option [value]="paymentStatus.Pending"> در انتظار تایید </option>
          <option [value]="paymentStatus.Approved"> تایید شده </option>
          <option [value]="paymentStatus.NotApproved"> رد شده </option>
        </select>
      </div>
    </div>
    <div class="w-full lg:w-3/12 px-4">
      <div class="relative w-full mb-3">
        <label class="block text-blueGray-600 text-sm font-bold mb-2"> وضعیت ویزیت </label>
        <select type="text" name="inshurance" [(ngModel)]="searchBody.status" (change)="getAllVisits(0)"
          class="border-gray-300 p-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full rtl">
          <option value="0">---</option>
          <option [value]="visitStatus.Pending"> در انتظار تایید </option>
          <option [value]="visitStatus.Approved"> تایید شده </option>
          <option [value]="visitStatus.Cancelled"> کنسل شده </option>
          <option [value]="visitStatus.Doing"> در حال انجام </option>
          <option [value]="visitStatus.Done"> انجام شده </option>
        </select>
      </div>
    </div>
  </div>

  <div class="flex-auto p-4">
    <div class="relative w-full overflow-x-auto rounded-md">
      <table class="w-full bg-transparent border-collapse">
        <thead class="bg-primary text-white">
          <tr>
            <th class="p-3 align-middle border border-solid text-base border-l-0 border-r-0 font-semibold">
              نام بیمار
            </th>
            <th class="p-3 align-middle border border-solid text-base border-l-0 border-r-0 font-semibold">
              نام پزشک
            </th>
            <th class="p-3 align-middle border border-solid text-base border-l-0 border-r-0 font-semibold">
              تاریخ
            </th>
            <th class="p-3 align-middle border border-solid text-base border-l-0 border-r-0 font-semibold">
              ساعت شروع
            </th>
            <th class="p-3 align-middle border border-solid text-base border-l-0 border-r-0 font-semibold">
              ساعت پایان
            </th>
            <th class="p-3 align-middle border border-solid text-base border-l-0 border-r-0 font-semibold">
              نوع ویزیت
            </th>
            <th class="p-3 align-middle border border-solid text-base border-l-0 border-r-0 font-semibold">
              وضعیت پرداختی
            </th>
            <th class="p-3 align-middle border border-solid text-base border-l-0 border-r-0 font-semibold">
              وضعیت ویزیت
            </th>
            <th class="p-3 align-middle border border-solid text-base border-l-0 border-r-0 font-semibold">
              پروفایل بیمار
            </th>
            <th class="p-3 align-middle border border-solid text-base border-l-0 border-r-0 font-semibold ">
              فایل‌های پیوست
            </th>
            <th class="p-3 align-middle border border-solid text-base border-l-0 border-r-0 font-semibold">
              نسخه پزشک
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let visit of visitsList" class="border-b">
            <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
              {{visit.userName}}
            </td>
            <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
              {{visit.doctorName}}
            </td>
            <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
              {{visit.date|shamsiDate}}
            </td>
            <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
              {{convertUTCMinutesToLocal(visit.startCounter)!='00:00'?convertUTCMinutesToLocal(visit.startCounter):'---'}}
            </td>
            <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
              {{calculateTime(visit.endCounter)!='00:00'?calculateTime(visit.endCounter):'---'}}
            </td>
            <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
              {{visit.type==1?'متنی':visit.type==2?'تلفنی':visit.type==3?'تصویری':visit.type==4?'حضوری':null}}
            </td>
            <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
              {{visit.paymentStatus==paymentStatus.Pending?'در انتظار تایید':
                visit.paymentStatus==paymentStatus.Approved?'تایید شده':
                visit.paymentStatus==paymentStatus.NotApproved?'رد شده':null}}
            </td>
            <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
              {{visit.status==visitStatus.Pending?'در انتظار تایید':
                visit.status==visitStatus.Approved?'تایید شده':
                visit.status==visitStatus.Doing?'در حال انجام':
                visit.status==visitStatus.Done?'انجام شده':
                visit.status==visitStatus.Cancelled?'کنسل شده':null}}
            </td>
            <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
              <button class="bg-primary text-white rounded p-1 text-sm" type="button"
                [routerLink]="'/admin/patient-info/'+visit.userInfoId">
                <img src="../../../../assets/img/icon/info-circle.svg" alt=""> </button>
            </td>
            <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
              <button (click)="tempVisit=visit;uploadedFile.open()" class="h-12 w-12 bg-white rounded-full cursor-pointer p-2 hover:bg-gray-100" >
                 <img src="../../../../assets/img/icon/document-upload.svg" class="w-9 h-8" alt="..."/>
              </button>
            </td>
            <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-3">
              <button (click)="tempVisit=visit;drFile.open()" class="h-12 w-12 bg-white rounded-full cursor-pointer p-2 hover:bg-gray-100" >
                <img src="../../../../assets/img/icon/document-upload.svg" class="w-9 h-8" alt="..."/>
              </button>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
    <div class="card flex justify-center">
      <p-paginator dir="rtl" (onPageChange)="getAllVisits($event.page)" [first]="first" [rows]="rows"
        [totalRecords]="collectionSize" [showCurrentPageReport]="true" [showPageLinks]="false"
        [showJumpToPageDropdown]="false" currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords} رکورد" />
    </div>
  </div>
</div>

<app-modal #drFile>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      نمایش نسخه
    </h3>
    <button
      class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
      (click)="drFile.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative p-6 flex-auto">
    <p *ngIf="!tempVisit?.doctorUploadFile||tempVisit?.doctorUploadFile==''" class="mt-4 mb-12 text-blueGray-500 text-lg text-start leading-relaxed">
      فایلی بارگزاری نشده است. 
    </p>
    <img *ngIf="getFileExtension(tempVisit?.doctorUploadFile)!='pdf'" [src]="apiService.api+tempVisit?.doctorUploadFile" class="max-w-md" alt="">
    <a class="flex items-center" *ngIf="getFileExtension(tempVisit?.doctorUploadFile)=='pdf'" [href]="apiService.api+tempVisit?.doctorUploadFile" target="_blank">
    <img src="../../../../assets/img/icon/file.svg" alt="">
    <span class="font-bold px-3"> نمایش فایل</span>
    </a>
  </div>
  <!--footer-->
  <div class="flex items-center justify-end py-2 border-solid border-blueGray-200 rounded-b">
    <button
      class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
      type="button" (click)="drFile.close();">
      بستن
    </button>
  </div>
</app-modal>


<app-modal #uploadedFile>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      مدارک پزشکی
    </h3>
    <button
      class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
      (click)="uploadedFile.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative p-6 flex-auto border-b" *ngIf="tempVisit?.files.length==0">
    <p class="mt-4 mb-12 text-blueGray-500 text-lg text-start leading-relaxed">
      فایلی بارگزاری نشده است. 
    </p>
  </div>
  <div class="relative p-6 flex-auto border-b" *ngFor="let file of tempVisit?.files">
    <!-- <a [href]="apiService.api+file" target="_blank">
    <img [src]="apiService.api+file" class="max-w-150-px" alt="">
    </a> -->

    <a [href]="apiService.api+file" target="_blank">
      <img *ngIf="getFileExtension(file)=='png'||getFileExtension(file)=='jpg'||getFileExtension(file)=='jpeg'" class="max-w-180-px h-auto" [src]="apiService.api+file" alt="">  
      <img *ngIf="getFileExtension(file)!=='png'&&getFileExtension(file)!=='jpg'&&getFileExtension(file)!=='jpeg'" src="../../../../assets/img/icon/file.svg" alt="">  
      <span *ngIf="getFileExtension(file)!=='png'&&getFileExtension(file)!=='jpg'&&getFileExtension(file)!=='jpeg'" class="font-bold px-3"> {{getFileExtension(file)}} </span>
    </a>
  </div>
  <!--footer-->
  <div class="flex items-center justify-end py-2 border-solid border-blueGray-200 rounded-b">
    <button
      class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
      type="button" (click)="uploadedFile.close();">
      بستن
    </button>
  </div>
</app-modal>